"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Paperclip: function() {
        return Paperclip;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Paperclip = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.6943 3.61769C16.4843 2.50853 14.6154 2.54913 13.4547 3.7098L4.45005 12.7145C2.49902 14.6655 2.50319 17.8387 4.45741 19.7929C6.41163 21.7471 9.58481 21.7513 11.5358 19.8002L21.2932 10.0429C21.6837 9.65235 22.3169 9.65235 22.7074 10.0429C23.0979 10.4334 23.0979 11.0666 22.7074 11.4571L12.95 21.2145C10.2148 23.9497 5.77527 23.9392 3.04319 21.2071C0.311121 18.475 0.300571 14.0355 3.03584 11.3002L12.0405 2.29559C13.9583 0.37776 17.0464 0.310666 19.0457 2.14338C21.1718 4.09227 21.2441 7.4204 19.2047 9.45981L10.2074 18.4571C8.98846 19.676 7.01215 19.676 5.79319 18.4571C4.57424 17.2381 4.57424 15.2618 5.79319 14.0429L14.2932 5.54288C14.6837 5.15235 15.3169 5.15235 15.7074 5.54288C16.0979 5.9334 16.0979 6.56657 15.7074 6.95709L7.20741 15.4571C6.76951 15.895 6.76951 16.605 7.20741 17.0429C7.64531 17.4808 8.35529 17.4808 8.7932 17.0429L17.7905 8.04559C19.0247 6.81135 18.981 4.79716 17.6943 3.61769Z",
        fill: "currentColor"
    })
}), "Paperclip");
const _default = Paperclip;
